/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
export const WEBSOCKET_CHANNELS = {
  roomEvents: (roomId: string) => `/rooms/${roomId}/activity`,
  idvSuccess: (sessionId: string) => `/session/${sessionId}/idv-success`,
};
